import { makeStyles } from "@material-ui/core/styles";
import { grey, blue } from "@material-ui/core/colors";

// D8.18.1 — Estilos de Dashboard.
export const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(2),
  },
  fixedHeightPaper: {
    padding: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    height: 240,
    overflowY: "auto",
    ...theme.scrollbarStyles,
  },
  cardAvatar: {
    fontSize: "55px",
    color: grey[500],
    backgroundColor: "#ffffff",
    width: theme.spacing(7),
    height: theme.spacing(7),
  },
  cardTitle: {
    fontSize: "18px",
    color: blue[700],
  },
  cardSubtitle: {
    color: grey[600],
    fontSize: "14px",
  },
  alignRight: {
    textAlign: "right",
  },
  fullWidth: {
    width: "100%",
  },
  selectContainer: {
    width: "100%",
    textAlign: "left",
  },
  iframeDashboard: {
    width: "100%",
    height: "calc(100vh - 64px)",
    border: "none",
  },
  customFixedHeightPaper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    height: 120,
  },
  customFixedHeightPaperLg: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    height: "100%",
  },
    card0: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    height: "100%",
    minHeight: 140,
    background: "linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)",
    color: "#ffffff",
    borderRadius: 12,
    boxShadow: "0 2px 12px rgba(14, 165, 233, 0.25)",
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 4px 20px rgba(14, 165, 233, 0.35)",
    },
    [theme.breakpoints.down('sm')]: {
      minHeight: 120,
      padding: theme.spacing(1.5),
    },
  },
  card00: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    height: "100%",
    minHeight: 140,
    background: "linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)",
    color: "#ffffff",
    borderRadius: 12,
    boxShadow: "0 2px 12px rgba(139, 92, 246, 0.25)",
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 4px 20px rgba(139, 92, 246, 0.35)",
    },
    [theme.breakpoints.down('sm')]: {
      minHeight: 120,
      padding: theme.spacing(1.5),
    },
  },
  card1: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    height: "100%",
    minHeight: 140,
    background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
    color: "#ffffff",
    borderRadius: 12,
    boxShadow: "0 2px 12px rgba(16, 185, 129, 0.25)",
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 4px 20px rgba(16, 185, 129, 0.35)",
    },
    [theme.breakpoints.down('sm')]: {
      minHeight: 120,
      padding: theme.spacing(1.5),
    },
  },
  card2: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    height: "100%",
    minHeight: 140,
    background: "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
    color: "#ffffff",
    borderRadius: 12,
    boxShadow: "0 2px 12px rgba(245, 158, 11, 0.25)",
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 4px 20px rgba(245, 158, 11, 0.35)",
    },
    [theme.breakpoints.down('sm')]: {
      minHeight: 120,
      padding: theme.spacing(1.5),
    },
  },
  card3: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    height: "100%",
    minHeight: 140,
    background: "linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)",
    color: "#ffffff",
    borderRadius: 12,
    boxShadow: "0 2px 12px rgba(99, 102, 241, 0.25)",
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 4px 20px rgba(99, 102, 241, 0.35)",
    },
    [theme.breakpoints.down('sm')]: {
      minHeight: 120,
      padding: theme.spacing(1.5),
    },
  },
  card4: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    height: "100%",
    minHeight: 140,
    background: "linear-gradient(135deg, #ec4899 0%, #db2777 100%)",
    color: "#ffffff",
    borderRadius: 12,
    boxShadow: "0 2px 12px rgba(236, 72, 153, 0.25)",
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 4px 20px rgba(236, 72, 153, 0.35)",
    },
    [theme.breakpoints.down('sm')]: {
      minHeight: 120,
      padding: theme.spacing(1.5),
    },
  },
  card5: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    height: "100%",
    minHeight: 140,
    background: "linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)",
    color: "#ffffff",
    borderRadius: 12,
    boxShadow: "0 2px 12px rgba(6, 182, 212, 0.25)",
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 4px 20px rgba(6, 182, 212, 0.35)",
    },
    [theme.breakpoints.down('sm')]: {
      minHeight: 120,
      padding: theme.spacing(1.5),
    },
  },
  card6: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    height: "100%",
    minHeight: 140,
    background: "linear-gradient(135deg, #14b8a6 0%, #0d9488 100%)",
    color: "#ffffff",
    borderRadius: 12,
    boxShadow: "0 2px 12px rgba(20, 184, 166, 0.25)",
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 4px 20px rgba(20, 184, 166, 0.35)",
    },
    [theme.breakpoints.down('sm')]: {
      minHeight: 120,
      padding: theme.spacing(1.5),
    },
  },
  card7: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    height: "100%",
    minHeight: 140,
    background: "linear-gradient(135deg, #f97316 0%, #ea580c 100%)",
    color: "#ffffff",
    borderRadius: 12,
    boxShadow: "0 2px 12px rgba(249, 115, 22, 0.25)",
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 4px 20px rgba(249, 115, 22, 0.35)",
    },
    [theme.breakpoints.down('sm')]: {
      minHeight: 120,
      padding: theme.spacing(1.5),
    },
  },
  card8: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    height: "100%",
    minHeight: 140,
    background: "linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)",
    color: "#ffffff",
    borderRadius: 12,
    boxShadow: "0 2px 12px rgba(59, 130, 246, 0.25)",
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 4px 20px rgba(59, 130, 246, 0.35)",
    },
    [theme.breakpoints.down('sm')]: {
      minHeight: 120,
      padding: theme.spacing(1.5),
    },
  },
  card9: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    height: "100%",
    minHeight: 140,
    background: "linear-gradient(135deg, #a855f7 0%, #9333ea 100%)",
    color: "#ffffff",
    borderRadius: 12,
    boxShadow: "0 2px 12px rgba(168, 85, 247, 0.25)",
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 4px 20px rgba(168, 85, 247, 0.35)",
    },
    [theme.breakpoints.down('sm')]: {
      minHeight: 120,
      padding: theme.spacing(1.5),
    },
  },
  cardBadge: {
    display: "inline-flex",
    alignItems: "center",
    padding: "4px 10px",
    borderRadius: 12,
    fontSize: "11px",
    fontWeight: 600,
    marginTop: theme.spacing(1),
    backgroundColor: "rgba(255, 255, 255, 0.2)",
    backdropFilter: "blur(10px)",
  },
  cardSubtext: {
    fontSize: "11px",
    opacity: 0.85,
    marginTop: theme.spacing(0.5),
    fontWeight: 400,
    [theme.breakpoints.down('sm')]: {
      fontSize: "10px",
    },
  },
  fixedHeightPaper2: {
    padding: theme.spacing(2.5),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    borderRadius: 12,
    backgroundColor: theme.palette.background.paper,
    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
    border: `1px solid ${theme.palette.divider}`,
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1.5),
    },
  },
}));
